module.exports = __webpack_public_path__ + "static/media/logo_aguardando.af1d25f7.gif";